module.exports = __webpack_public_path__ + "static/media/defects.e489dde4.svg";